<template>
  <!-- 首页 -->
  <div id="Home">
    <!-- 内容区域 -->
    <el-container style="height: 100%; width: 100%;">
      <!-- <el-header>Header</el-header> -->
      <el-main style="padding: 0px;">
        <HomeList style="height: 100%; width: 100%;"></HomeList>
      </el-main>
      <el-footer style="padding: 0 0px;background-color: #fff;">
            <BottomNav style="height: 100%; width: 100%;"></BottomNav>
            </el-footer>
    </el-container>
  </div>
</template>

<script>
  // import img_url2 from '../assert/image/btn_1_0.png';
  import HomeList from './HomeList.vue';
  import BottomNav from './Bottom-nav.vue'
  import { lStorage, sStorage } from "@Comm/js/Storage.js"
  export default {
      data() {
        return {
          // //表格
          // tableData: [],
          // pageIndex: 1,
          // //下拉刷新，上拉加载
          // refreshing: false,
          // loadings: false,
          // loadedall: false
        }
      },
      mounted() {
       //  console.log(Vue.prototype.Calculate.Monitor.HJShipList[0][0])
       // this.tableHJAll=Vue.prototype.Calculate.Monitor.HJShipList[0][0];
  //       console.log(this.tableHJAll);
  //       this.$nextTick(function() {
  //         that.$refs.multipleTable.style.maxHeight = (window.innerHeight - this.$refs.multipleTable.offsetTop +
  //           "px");
  //         // // 监听窗口大小变化
  //         // let self = this;
  //         window.onresize = function() {
  //           that.$refs.multipleTable.style.maxHeight = (window.innerHeight - this.$refs.multipleTable.offsetTop +
  //             "px");
  //         }
  //       });

  //       const that = this;
  //       $(window).load(function() { //所有页面加载完成后调用
  //         that.$refs.multipleTable.style.maxHeight = (window.innerHeight - that.$refs.multipleTable.offsetTop +
  //           "px");
  //       })
  //       this.refresh();
      },
      methods: {
        // back() {
        //   this.$router.go(-1); //返回上一层
        //   // history.back(-1);
        // },

        //分页读取数据
        // loadShipList(pageSize, pageIndex) {
        //   const that = this;
        //   that.refreshing = false;
        //   that.loadings = false;
        //   if(Vue.prototype.Calculate.Monitor.HJShipList){
        //      that.tableHJAll=Vue.prototype.Calculate.Monitor.HJShipList[0][0];
        //   }
        //   if (that.pageIndex > 1) {
        //     that.$refs.container.scrollTop = that.$refs.container.scrollTop - 1;
        //     //console.log(this.tableHJAll.slice(pageIndex,pageSize))
        //     that.tableHJData = that.tableHJData.concat(that.tableHJAll.slice((pageIndex-1)*pageSize,pageIndex*pageSize));
        //     // that.loadedall=true;
        //   } else {
        //     console.log(that.tableHJAll.slice((pageIndex-1)*pageSize,pageIndex*pageSize));
        //     that.$refs.container.scrollTop = 0;
        //     that.tableHJData = that.tableHJAll.slice((pageIndex-1)*pageSize,pageIndex*pageSize);
        //    // that.tableHJData = data;
        //   }
        //   if (Vue.prototype.Calculate.pageTotal(that.tableHJAll.length, 20) == that.pageIndex) {
        //     that.loadedall = true;
        //   }
        // },

        //2022-02-21 XSY添加：搜索框功能 结束

        // //下拉刷新数据
        // refresh() {
        //   this.refreshing = true;
        //   this.pageIndex = 1;
        //   // this.loadShipList(20, this.pageIndex);
        // },
        // //上拉加载数据
        // loadsss() {
        //   this.loadings = true;
        //   this.pageIndex++;
        //   console.log(this.pageIndex);
        //   // this.loadShipList(20, this.pageIndex);
        // }
      },
    components: {
      HomeList,
      BottomNav
    }
    };
</script>

<style>
  </style>

<style lang='less'>
  #Home .mu-appbar .mu-appbar-title {
      text-align: center;
  }

  #Home .is-full-width {
    width: 100%;
  }

  #Home .content {
    flex: 1
  }

  /* #Home {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 0;
      overflow-x: hidden;
      overflow-y: hidden;
    } */
  #Home .container {
    width: 100%;
    height: 70%;
    padding-right: 0px;
    padding-left: 0px;
    /* margin-right: auto; */
    /* margin-left: auto; */
  }



#Home .mu-card-media {
    position: relative;
    margin: 15px;
    margin-left: 25px;
    margin-right: 25px;
  /*  position: absolute;
    z-index: 0; */
    /* border-radius: 30px; */
}
#Home .mu-card-media>img {
    border-radius: 5px;
}

  @import '../../Comm/css/CommCSS.css';

</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Home.vue